import { Injectable } from '@angular/core';
import { VariablesService } from '../../globalService/variables.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModuloService {

  sendModulesFn: Function;
  //Administración
  administracion = 50;
  usuarios = 119;
  auditoria = 57;
  parametricas = 120;
  //-----------------//

  //Configuración
  configuracion = 53;
  grupoEconomico = 121;
  empresas = 122;
  roles = 123;
  modulos = 124;
  //----------------//

  //WePAC'S
  pacs = 59;
  creacionProgramaYContratista = 60;
  solicitudDePolizaYModificaciones = 80;
  facturacion = 87;
  controlCuposyCumulos = 89;
  controlDeGarantias = 92;
  polizasGlobal = 94;
  solicitudConsultasTecnicas = 88;
  reportesConsultasReportes = 144;
  gestionSolicitudes = 177;
  workflow = 58;
  autorizacionMoraSarlaft = 65;
  polizasEmitidasPorFueraDelPrograma = 1002;
  //---------------//

  //Siniestros
  siniestros = 103;
  radicacion = 104;
  incumplimineto = 108;
  consultaYReportes = 106;
  //-----------------//

  //Sarlaft
  sarlaft = 112;
  consultaModificacionSarlaft = 141;
  reporteSarlaft = 1003;
  //----------------//

  //Administracion Comercial
  administracionComercial = 113;
  //---------------//

  //Administración
  administracionMenu = false;
  usuariosMenu = false;
  auditoriaMenu = false;
  parametricasMenu = false;
  //----------------//
  //Configuración
  configuracionMenu = false;
  grupoEconomicoMenu = false;
  empresasMenu = false;
  rolesMenu = false;
  modulosMenu = false;
  //---------------//
  //WePAC'S
  pacsMenu = false;
  creacionProgramaYContratistaMenu = false;
  solicitudDePolizaYModificacionesMenu = false;
  facturacionMenu = false;
  controlCuposyCumulosMenu = false;
  controlDeGarantiasMenu = false;
  polizasGlobalMenu = false;
  solicitudConsultasTecnicasMenu = false;
  reportesConsultasReportesMenu = false;
  gestionSolicitudesMenu = false;
  workflowMenu = false;
  autorizacionMoraSarlaftMenu = false;
  polizasEmitidasPorFueraDelProgramaMenu = false;
  //--------------//
  //Siniestros
  siniestrosMenu = false;
  radicacionMenu = false;
  incumpliminetoMenu = false;
  consultaYReportesMenu = false;
  //------------------------//
  //Sarlaft
  sarlaftMenu = false;
  consultaModificacionSarlaftMenu = false;
  reporteSarlaftMenu = false;
  //-------------------//
  //Tablero de Control
  administracionComercialMenu = false;
  //------------------//
  //---------------//
  //WeCumplimineto
  weCumplimiento = 1004;
  weCumplimientoMenu = false;
  weCumplimientoGenerarSolicitud = 1005;
  weCumplimientoGenerarSolicitudMenu = false;
  weCumplimientoSolicitudesRecibidas = 1006;
  weCumplimientoSolicitudesRecibidasMenu = false;
  weCumplimientoReportes = 1007;
  weCumplimientoReportesMenu = false;
  weCumplimientoCuposCumulos = 1008;
  weCumplimientoCuposCumulosMenu = false;
  weCumplimientoNegociacionAseguradora = 1015;
  weCumplimientoNegociacionAseguradoraMenu = false;
  //---------------//
  modules: any[] = [];

  constructor(private _variableService: VariablesService) {
    this.getVariables();
  }

  async getVariables() {
    await new Promise((resolve, reject) => {
      this._variableService.getVariables().then(() => {
        this.administracion = this._variableService.data.modulos.Administracion;
        this.usuarios = this._variableService.data.modulos.Usuarios;
        this.auditoria = this._variableService.data.modulos.Auditoria;
        this.parametricas = this._variableService.data.modulos.Parametricas;

        this.configuracion = this._variableService.data.modulos.Configuracion;
        this.grupoEconomico = this._variableService.data.modulos.GrupoEconomico;
        this.empresas = this._variableService.data.modulos.Empresas;
        this.roles = this._variableService.data.modulos.Roles;
        this.modulos = this._variableService.data.modulos.Modulos;

        this.pacs = this._variableService.data.modulos.PACs;
        this.creacionProgramaYContratista = this._variableService.data.modulos.CreacionProgramasyContratistas;
        this.solicitudDePolizaYModificaciones = this._variableService.data.modulos.SolicitudDePolizasyModificaciones;
        this.facturacion = this._variableService.data.modulos.Facturacion;
        this.controlCuposyCumulos = this._variableService.data.modulos.ControlDeCuposyCumulos;
        this.controlDeGarantias = this._variableService.data.modulos.ControlDeGarantias;
        this.polizasGlobal = this._variableService.data.modulos.PolizasGlobal;
        this.solicitudConsultasTecnicas = this._variableService.data.modulos.SolicitudConsultasTecnicas;
        this.reportesConsultasReportes = this._variableService.data.modulos.ReportesConsultaDeReportes;
        this.gestionSolicitudes = this._variableService.data.modulos.GestionDeSolicitudes;
        this.workflow = this._variableService.data.modulos.WorkFlow;
        this.autorizacionMoraSarlaft = this._variableService.data.modulos.AutorizacionMoraSarlaft;
        this.polizasEmitidasPorFueraDelPrograma = this._variableService.data.modulos.PolizasEmitidasPorFueraDelPrograma;

        this.siniestros = this._variableService.data.modulos.Siniestros;
        this.radicacion = this._variableService.data.modulos.Radicacion;
        this.incumplimineto = this._variableService.data.modulos.AvisoDePosibleIncumplimiento;
        this.consultaYReportes = this._variableService.data.modulos.ConsultasyReportesParaElCliente;

        this.sarlaft = this._variableService.data.modulos.Sarlaft;
        this.consultaModificacionSarlaft = this._variableService.data.modulos.ConsultaModificacionDeSarlaft;
        this.reporteSarlaftMenu = this._variableService.data.modulos.ReporteSarlaft;
        this.administracionComercial = this._variableService.data.modulos.AdministracionComercial;

        this.weCumplimiento = this._variableService.data.modulos.weCumplimiento;
        this.weCumplimientoGenerarSolicitud = this._variableService.data.modulos.weCumplimientoGenerarSolicitud;
        this.weCumplimientoSolicitudesRecibidas = this._variableService.data.modulos.weCumplimientoSolicitudesRecibida;
        this.weCumplimientoCuposCumulos = this._variableService.data.modulos.weCumplimientoCuposCumulos;
        this.weCumplimientoReportes = this._variableService.data.modulos.weCumplimientoReportes;
        this.weCumplimientoNegociacionAseguradora = this._variableService.data.modulos.weCumplimientoNegociacionAseguradora;
        resolve(true);
      });
    });
  }

  async setModules(modules: any[]) {
    if (typeof this._variableService.data === 'undefined' || this._variableService.data == null) {
      await this.getVariables();
    }

    this.modules = modules;
    this.administracionMenu = this.modules.includes(this.administracion);
    this.usuariosMenu = this.modules.includes(this.usuarios);
    this.auditoriaMenu = this.modules.includes(this.auditoria);
    this.parametricasMenu = this.modules.includes(this.parametricas);
    this.configuracionMenu = this.modules.includes(this.configuracion);
    this.grupoEconomicoMenu = this.modules.includes(this.grupoEconomico);
    this.empresasMenu = this.modules.includes(this.empresas);
    this.rolesMenu = this.modules.includes(this.roles);
    this.modulosMenu = this.modules.includes(this.modulos);
    this.pacsMenu = this.modules.includes(this.pacs);
    this.creacionProgramaYContratistaMenu = this.modules.includes(this.creacionProgramaYContratista);
    this.solicitudDePolizaYModificacionesMenu = this.modules.includes(this.solicitudDePolizaYModificaciones);
    this.facturacionMenu = this.modules.includes(this.facturacion);
    this.controlCuposyCumulosMenu = this.modules.includes(this.controlCuposyCumulos);
    this.controlDeGarantiasMenu = this.modules.includes(this.controlDeGarantias);
    this.polizasGlobalMenu = this.modules.includes(this.polizasGlobal);
    this.solicitudConsultasTecnicasMenu = this.modules.includes(this.solicitudConsultasTecnicas);
    this.reportesConsultasReportesMenu = this.modules.includes(this.reportesConsultasReportes);
    this.siniestrosMenu = this.modules.includes(this.siniestros);
    this.radicacionMenu = this.modules.includes(this.radicacion);
    this.incumpliminetoMenu = this.modules.includes(this.incumplimineto);
    this.consultaYReportesMenu = this.modules.includes(this.consultaYReportes);
    this.sarlaftMenu = this.modules.includes(this.sarlaft);
    this.reporteSarlaftMenu = this.modules.includes(this.reporteSarlaft)
    this.administracionComercialMenu = this.modules.includes(this.administracionComercial);
    this.gestionSolicitudesMenu = this.modules.includes(this.gestionSolicitudes);
    this.workflowMenu = this.modules.includes(this.workflow);
    this.autorizacionMoraSarlaftMenu = this.modules.includes(this.autorizacionMoraSarlaft);
    this.polizasEmitidasPorFueraDelProgramaMenu = this.modules.includes(this.polizasEmitidasPorFueraDelPrograma); 
    this.weCumplimientoMenu = this.modules.includes(this.weCumplimiento);
    this.weCumplimientoGenerarSolicitudMenu = this.modules.includes(this.weCumplimientoGenerarSolicitud);
    this.weCumplimientoSolicitudesRecibidasMenu = this.modules.includes(this.weCumplimientoSolicitudesRecibidas);
    this.weCumplimientoReportesMenu = this.modules.includes(this.weCumplimientoReportes);
    this.weCumplimientoCuposCumulosMenu = this.modules.includes(this.weCumplimientoCuposCumulos);
    this.weCumplimientoNegociacionAseguradoraMenu = this.modules.includes(this.weCumplimientoNegociacionAseguradora);
  }

}